import React, { useContext } from 'react';
import { Button, Icon } from 'anf-core-react';
import { useQuery } from '@apollo/client';
import GET_BRANCH_URL from './branchUrlQuery';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function AppExclusiveButton({
  brand,
  label,
  isButtonDisabled = false,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const { collectionData } = ProductPageState;

  // Only fetch Branch URL when this component is rendered (i.e., when App Exclusive)
  const { data: branchUrlData, loading: branchUrlLoading } = useQuery(GET_BRANCH_URL, {
    variables: {
      collectionId: ProductPageState.collectionId,
      kic: collectionData.activeProduct?.kicId,
    },
    skip: !collectionData.activeProduct?.kicId, // Skip if no kicId available
  });

  const handleOpenApp = () => {
    window.location.href = branchUrlData?.branchUrl;
  };

  const isDisabled = isButtonDisabled || branchUrlLoading || !branchUrlData?.branchUrl;

  return (
    <div className="product-app-exclusive-button-container" data-product-brand={brand === 'gh' ? 'hol' : brand} data-testid="product-app-exclusive-button-container">
      <Button
        classList="product-app-exclusive-button-container_button"
        variant="secondary"
        brand={brand === 'gh' ? 'hol' : brand}
        isFullWidth
        isDisabled={isDisabled}
        isProcessing={branchUrlLoading}
        onClick={handleOpenApp}
      >
        <Icon icon="phone-anf" />
        {label}
      </Button>
    </div>
  );
}
